"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.TextAreaField = void 0;
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var __1 = require("..");
var styles_scss_1 = __importDefault(require("./styles.scss"));
var TextAreaField = function (_a) {
    var _b;
    var id = _a.id, labelText = _a.labelText, description = _a.description, _c = _a.variant, variant = _c === void 0 ? "default" : _c, _d = _a.inline, inline = _d === void 0 ? false : _d, _e = _a.reversed, reversed = _e === void 0 ? false : _e, _f = _a.status, status = _f === void 0 ? "default" : _f, validationMessage = _a.validationMessage, _g = _a.disabled, disabled = _g === void 0 ? false : _g, textAreaProps = __rest(_a, ["id", "labelText", "description", "variant", "inline", "reversed", "status", "validationMessage", "disabled"]);
    var renderDescriptionOnTop = variant === "prominent";
    var renderDescription = function (position) {
        var _a;
        if (!description)
            return null;
        return (React.createElement("div", { className: (0, classnames_1["default"])(styles_scss_1["default"].message, (_a = {},
                _a[styles_scss_1["default"].disabled] = disabled,
                _a)) },
            React.createElement(__1.FieldMessage, { id: "".concat(id, "-field-message"), automationId: "".concat(id, "-field-description"), message: description, reversed: reversed, position: position })));
    };
    return (React.createElement(__1.FieldGroup, { id: "".concat(id, "-field-group"), inline: inline, automationId: "".concat(id, "-field-group"), className: disabled ? styles_scss_1["default"].disabled : undefined },
        React.createElement("div", { className: (0, classnames_1["default"])(styles_scss_1["default"].textareaLabel, (_b = {},
                _b[styles_scss_1["default"].textareaLabelProminent] = variant === "prominent",
                _b)) },
            React.createElement(__1.Label, { id: "".concat(id, "-field-label"), automationId: "".concat(id, "-field-label"), htmlFor: "".concat(id, "-field-textarea"), labelText: labelText, reversed: reversed, variant: variant, disabled: disabled })),
        renderDescriptionOnTop && renderDescription("top"),
        React.createElement(__1.TextArea, __assign({ id: "".concat(id, "-field-textarea"), automationId: "".concat(id, "-field-textarea"), reversed: reversed, status: status, disabled: disabled }, textAreaProps)),
        !disabled && validationMessage && (React.createElement(__1.FieldMessage, { id: "".concat(id, "-field-message"), automationId: "".concat(id, "-field-validation-message"), message: validationMessage, status: status, reversed: reversed })),
        !renderDescriptionOnTop && renderDescription("bottom")));
};
exports.TextAreaField = TextAreaField;
exports.TextAreaField.displayName = "TextAreaField";
//# sourceMappingURL=TextAreaField.js.map